/**
 * @class
 * @function BackToTop
 */
if (!customElements.get('back-to-top')) {
  class BackToTop extends HTMLElement {
    constructor() {
      super();
      this.pageHeight = window.innerHeight;
      this.ready = false;
      this.onScroll = this.checkVisible.bind(this);
      this.onResize = this.updatePageHeight.bind(this);
    }

    connectedCallback() {
      // Stil gelmeden / sayfa oturmadan asla gösterme
      this.classList.remove('back-to-top--active');
      this.setAttribute('aria-hidden', 'true');
      this.hidden = true;

      this.addEventListener('click', this.onClick);
      this.addEventListener('touchstart', this.onClick, { passive: true });

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });

      // Layout ve scroll restore bitince aktif et
      const enable = () => {
        this.ready = true;
        this.hidden = false;
        this.updatePageHeight();
        this.checkVisible();
      };

      if (document.readyState === 'complete') {
        // Bir frame bekle: scroll restoration / view-transition bitsin
        requestAnimationFrame(() => requestAnimationFrame(enable));
      } else {
        window.addEventListener('load', () => {
          requestAnimationFrame(() => requestAnimationFrame(enable));
        }, { once: true });
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
    }

    updatePageHeight() {
      this.pageHeight = window.innerHeight;
    }

    checkVisible() {
      if (!this.ready) return;

      window.requestAnimationFrame(() => {
        const y = window.scrollY || window.pageYOffset || 0;
        const shouldShow = y > this.pageHeight;

        if (shouldShow) {
          this.classList.add('back-to-top--active');
          this.setAttribute('aria-hidden', 'false');
        } else {
          this.classList.remove('back-to-top--active');
          this.setAttribute('aria-hidden', 'true');
        }
      });
    }

    onClick() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }
  }

  customElements.define('back-to-top', BackToTop);
}
